import React from 'react';
import styled from '@emotion/styled';

const toggleHeight = 25;
const toggleWidth = 50;
const circleSize = toggleHeight;

const Wrapper = styled.div`
  display: flex;
  flex: 1;
`;

const LeftContainer = styled.div`
  flex: 1;
  // Center children
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Label = styled.div`
  /* font-size: 12px; */
  /* color: #757575; */
`;

const SubLabel = styled.div`
  font-size: 12px;
  color: #757575;
`;

const ToggleWrapper = styled.div<{
  active: boolean;
}>`
  width: ${toggleWidth}px;
  height: ${toggleHeight}px;
  border-radius: 15px;
  background: ${(props) => (props.active ? '#6aa84f' : '#ececec')};
  border: solid 1px #ababab;
  position: relative;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;
  margin-left: 16px;
`;

const ToggleCircle = styled.div<{
  active: boolean;
}>`
  width: ${circleSize}px;
  height: ${circleSize}px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  left: ${(props) => (props.active ? `${toggleWidth - circleSize}px` : 0)};
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1);
  border: solid 1px #e2e2e2;
  box-sizing: border-box;
`;

interface Props {
  label?: string;
  subLabel?: string;
  value: boolean;
  onClick: (value: boolean) => void;
}

const Toggle: React.FunctionComponent<Props> = ({ label, subLabel, value, onClick }) => {
  const handleClick = () => {
    onClick(!value);
  };
  return (
    <Wrapper>
      {label && (
        <LeftContainer>
          <Label>{label}</Label>
          {subLabel && <SubLabel>{subLabel}</SubLabel>}
        </LeftContainer>
      )}
      <ToggleWrapper active={value} onClick={handleClick}>
        <ToggleCircle active={value} />
      </ToggleWrapper>
    </Wrapper>
  );
};

export default Toggle;
